import styled, { css } from 'styled-components';
export {
  Backdrop,
  CloseButton,
  CloseIcon,
  Panel as Root,
  Title,
} from 'src/components/SideDrawer/styles';

export const FeaturesContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s2};
    margin-bottom: ${theme.sz.s5};
  `,
);

export const FeatureRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: ${theme.sz.s3} 0;
    border-bottom: 1px solid ${theme.co.neutral40};
    width: 100%;
    gap: ${theme.sz.s3};

    &:last-of-type {
      border-bottom: none;
    }
  `,
);

export const FeatureInfo = styled.div(
  () => css`
    flex: 1;
    min-width: 0;
  `,
);

export const FeatureLabel = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    color: ${theme.co.primary99};
    margin-bottom: ${theme.sz.s1};
  `,
);

export const FeatureDescription = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.neutral70};
    margin-top: ${theme.sz.s1};
  `,
);

export const SettingsLink = styled.a(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.primary40};
    text-decoration: none;
    display: block;
    text-align: center;
    margin-top: ${theme.sz.s2};

    &:hover {
      text-decoration: underline;
    }
  `,
);

export const TracingSection = styled.div(
  ({ theme }) => css`
    border-top: 1px solid ${theme.co.neutral40};
    padding-top: ${theme.sz.s3};
    margin-top: ${theme.sz.s2};
  `,
);

export const DifficultyOptions = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s2};
    padding: ${theme.sz.s2} 0;
    padding-left: ${theme.sz.s2};
  `,
);

export const DifficultyOption = styled.label(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.sz.s2};
    cursor: pointer;
  `,
);

export const DifficultyRadio = styled.input(
  ({ theme }) => css`
    margin-top: 3px;
    accent-color: ${theme.co.primary40};
  `,
);

export const DifficultyLabel = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.primary99};
  `,
);

export const DifficultyDescription = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.neutral70};
    display: block;
  `,
);
